import React, { useState, useEffect } from 'react';
import './preloader.css';

const Preloader = ({ onComplete }) => {
    const [visibleLetters, setVisibleLetters] = useState([]);
    const [progress, setProgress] = useState(0);
    const [isVisible, setIsVisible] = useState(true);

    const word = "REFRESH";
    const letters = word.split('');

    useEffect(() => {
        // Анимация появления букв
        const letterTimers = letters.map((_, index) =>
            setTimeout(() => {
                setVisibleLetters(prev => [...prev, index]);
            }, 100 * index)
        );

        // Анимация прогресс-бара
        const progressTimer = setInterval(() => {
            setProgress(prev => {
                if (prev >= 100) {
                    clearInterval(progressTimer);
                    return 100;
                }
                return prev + 1;
            });
        }, 10);

        // Завершение анимации

        const completionTimer = setTimeout(() => {

            //setIsVisible(false);

            setTimeout(() => {
                onComplete?.();
            }, 500);

        }, 1500);


        return () => {
            letterTimers.forEach(timer => clearTimeout(timer));
            clearInterval(progressTimer);
            clearTimeout(completionTimer);
        };
    }, [onComplete]);

    if (!isVisible) return null;

    return (
        <div className="preloader">
            <div className="word-container">
                {letters.map((letter, index) => (
                    <span
                        key={index}
                        className={`letter ${visibleLetters.includes(index) ? 'visible' : ''}`}
                        style={{ animationDelay: `${index * 0.1}s` }}
                    >
                        {letter}
                    </span>
                ))}
            </div>

            <div className="progress-container">
                <div
                    className="progress-bar"
                    style={{ width: `${progress}%` }}
                />
                <div className="progress-text">{progress}%</div>
            </div>
        </div>
    );
};

export default Preloader;
